export type SlotShape = 'circle' | 'flower' | 'square' | 'seal' | 'hexagon';

/** 0 eliminada · 1 borrador · 2 publicada · 3 archivada */
export enum LoyaltyCardStatus {
  Deleted = 0,
  Draft = 1,
  Published = 2,
  Archived = 3,
}

export interface ILoyaltyCardMetrics {
  clients: number;
  stamps: number;
  redeemed: number;
}

export interface ILoyaltyCardSocialNetwork {
  idSocialNetwork: string;
  name: string;
  code: string;
  value: string;
  enabled: boolean;
}

export interface ILoyaltyCard {
  idLoyaltyCard: string;
  name: string;
  status: LoyaltyCardStatus;
  statusLabel?: string;
  version: number;
  publishedAt?: string | null;
  updatedAt?: string | null;
  idFrontFile?: string | null;
  frontFileUrl?: string | null;
  backgroundColor: string;
  slotColor: string;
  slotShape: SlotShape;
  stampsRequired: number;
  textColor: string;
  backText?: string | null;
  rewardName?: string | null;
  terms?: string | null;
  socialNetworks?: ILoyaltyCardSocialNetwork[];
  metrics?: ILoyaltyCardMetrics;
}

export interface ILoyaltyCardCounts {
  all: number;
  draft: number;
  published: number;
  archived: number;
}

export interface ILoyaltyCardRequest {
  name: string;
  idFrontFile: string | null;
  backgroundColor: string;
  slotColor: string;
  slotShape: SlotShape;
  stampsRequired: number;
  textColor: string;
  backText: string;
  rewardName: string;
  terms: string;
  socialNetworks?: string[];
}

export const SLOT_SHAPES: { value: SlotShape; label: string }[] = [
  { value: 'circle', label: 'Círculo' },
  { value: 'flower', label: 'Flor' },
  { value: 'square', label: 'Cuadrado' },
  { value: 'seal', label: 'Sello' },
  { value: 'hexagon', label: 'Hexágono' },
];

export const DEFAULT_CARD: Omit<ILoyaltyCardRequest, 'name'> = {
  idFrontFile: null,
  backgroundColor: '#3B2116',
  slotColor: '#BCDDE8',
  slotShape: 'circle',
  stampsRequired: 10,
  textColor: '#FFFFFF',
  backText: 'Junta 10 sellos y llévate un premio',
  rewardName: '',
  terms: '',
  socialNetworks: [],
};
